// extracted by mini-css-extract-plugin
export default {"ratingLabel":"ProductDetailRating_ratingLabel__0VD8j","ratingIcon":"ProductDetailRating_ratingIcon__vi05s"};